export const capitalizeFirstLetter = (str: string) =>
  str && `${str.charAt(0).toUpperCase()}${str.slice(1)}`;
